// @flow
import React from 'react'

type Props = {
  label: string,
  value: string
}

const DropdownTrigger = ({ label, value }: Props) => (
  <span className="flyer-dropdown-trigger">
    <span className="flyer-dropdown-trigger__label">
      {label}
      <span className="mobile hidden">:</span>
    </span>
    <span className="mobile hidden">{value}</span>
  </span>
)

export default DropdownTrigger



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerGridMenu/components/DropdownTrigger.js